export function addStylesToVisibleWidget() {
    var applyStyles = function(widget) {
        widget.style.animation = 'pulsate 5s infinite!important';
        widget.style.transform = 'none!important';
        widget.style.webkitTransform = 'none!important';
    };

    var checkForWidget = function() {
        var widget = document.querySelector('.widget-visible');
        if (widget) {
            applyStyles(widget);
        } else {
            setTimeout(checkForWidget, 100); // Check again after 100ms
        }
    };

    checkForWidget();
}
